/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';

import PaymentLabels from '../../../../common/components/modules/sports/PaymentLabelsLeft';
import LayoutInside from '../../../../common/components/layout/LayoutInside';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDefyById, resetStateDefyResponse } from '../../../../modules/sport/actions/reducerDefy';
import Loading from '../../../../common/loading/Loading';
import { format } from 'date-fns';
import { attributesBySport } from '../../../../common/data/attributes';
import { formatPrice } from '../../../../utils';
import { useAuth } from '../../../../context/auth-context';
import Image from '../../../../common/Image';
import WebPayLogo from '../../../../common/components/images/webpay-plus.svg';
import Button from '../../../../common/components/sections/Button';
import { createModel } from '../../../../services/api.service';
import { teamProfileGet } from '../../../../modules/sport/actions/reducerTeam';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Challenge = (): JSX.Element => {
    const auth = useAuth();
    const inputRefButton = useRef<HTMLDivElement>();
    const attribute = attributesBySport('defy');
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const [title, setTitle] = useState<string>();
    const [error, setError] = useState<string>('');
    const [msj, setMsj] = useState<string>('');
    const challengeId = query.get('challengeId');
    const selectDefy = (state: any) => state.defy;
    const defy = useSelector(selectDefy);
    const selectDefyResponse = (state: any) => state.defyResponse;
    const defyResponse = useSelector(selectDefyResponse);
    const [detDefy, setDetDefy] = useState<any | null>(null);
    const [statusCancel, setStatusCancel] = useState(false);
    const [participate, setParticipate] = useState(false);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const day = query.get('day');
    const region = query.get('region');
    const commune = query.get('commune');
    const [timeDefy, setTimeDefy] = useState(false);
    const mydate = new Date();
    const [statusPay, setStatusPay] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [isRedirecting, setIsRedirecting] = useState(false);
    const [deposit, setDeposit] = useState<number>();
    const [capacity, setCapacity] = useState<string>('');

    const pathnameDefys = `/${sport}/desafiar/equipos/filter`;

    const pathnameAll = window.location.pathname + useLocation().search;

    const [breads, setBreads] = useState([
        {
            key: 'desafiar',
            name: 'Desafíar | Buscar',
            url: `/integrar`,
            add: true,
        },
        {
            key: 'equipos',
            name: 'Equipos',
            url: pathnameDefys,
            add: false,
        },
        {
            key: 'pago',
            name: 'Pago',
            url: pathnameAll,
            add: false,
        },
    ]);

    useEffect(() => {
        dispatch(teamProfileGet(sport));
    }, []);

    useEffect(() => {
        setDetDefy(null);
        dispatch(resetStateDefyResponse());
        dispatch(fetchDefyById(challengeId, auth.isLoggedIn));
    }, [challengeId]);

    useEffect(() => {
        if (day || region || commune) {
            const pathQuery = `?region=${region}&commune=${commune}&day=${day}`;

            const pathnameDefys = `/${sport}/desafiar/equipos/filter${(day || region || commune) && pathQuery}`;

            setBreads([
                {
                    key: 'desafiar',
                    name: 'Desafíar | Buscar',
                    url: `/integrar`,
                    add: true,
                },
                {
                    key: 'equipos',
                    name: 'Equipos',
                    url: pathnameDefys,
                    add: false,
                },
                {
                    key: 'pago',
                    name: 'Pago',
                    url: pathnameAll,
                    add: false,
                },
            ]);
        }
    }, [day, region, commune]);

    useEffect(() => {
        if (defy) {
            if (defy.data && defy.data.data && defy.data.statusCode === 'CHALLENGES_BY_ID') {
                //console.log(defy.data.data);
                setStatusCancel(false);
                const newDefy = defy.data.data;
                setDetDefy(newDefy);
            }
        }
    }, [defy]);

    useEffect(() => {
        //console.log({ defyResponse });
        if (defyResponse) {
            if (defyResponse.error) {
                setError(defyResponse.error);
            }
        }
    }, [defyResponse]);

    useEffect(() => {
        if (detDefy && detDefy.reservation && detDefy.reservation.start) {
            const regionId = detDefy.reservation.field?.club?.regionId;
            const countyId = detDefy.reservation.field?.club?.countyId;
            const capacityTeam =
                detDefy.reservation.field?.capacity > 0 ? Math.round(detDefy.reservation.field?.capacity / 2) : '';
            setCapacity(` ${capacityTeam}x${capacityTeam} `);
            if (!(day || region || commune)) {
                const pathnameDefys = `/${sport}/desafiar/equipos/filter?region=${regionId}&commune=${countyId}`;

                setBreads([
                    {
                        key: 'desafiar',
                        name: 'Desafíar | Buscar',
                        url: `/integrar`,
                        add: true,
                    },
                    {
                        key: 'equipos',
                        name: 'Equipos',
                        url: pathnameDefys,
                        add: false,
                    },
                    {
                        key: 'pago',
                        name: 'Pago',
                        url: pathnameAll,
                        add: false,
                    },
                ]);
            }
            // format: detDefy.reservation.field.format?.name || '', activar cuando me avisen
            setDateMatch({
                start: format(new Date(detDefy.reservation?.start), "H':'mm"),
                date: format(new Date(detDefy.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detDefy.reservation.end), "H':'mm"),
                format: '',
                club: detDefy.reservation.field.club?.name || '',
            });
            const time: number = Date.parse(detDefy.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeDefy(true);
            } else {
                setTimeDefy(false);
            }
            //setDeposit(detDefy.challengePriceTeam);
            let activeMsjAbono = 'Para realizar la reserva debes abonar';

            if (detDefy?.reservation?.discountPercentage > 0) {
                let total = detDefy.reservation.discountPercentage;
                if (
                    (detDefy.challengerParticipate &&
                        detDefy.challengerParticipate === true &&
                        detDefy.challengerStatusPaid === 'PARTIAL_PAYMENT') ||
                    (detDefy.challengedParticipate &&
                        detDefy.challengedParticipate === true &&
                        detDefy.challengedStatusPaid === 'PARTIAL_PAYMENT')
                ) {
                    total = detDefy?.challengePriceTeam - detDefy.reservation.discountPercentage;
                    activeMsjAbono = 'El monto para completar el pago es: ';
                }
                if (total && total > 0) {
                    setMsj(
                        `El pago por equipo de este partido es de ${formatPrice(
                            detDefy.challengePriceTeam,
                            0,
                        )}\n${activeMsjAbono} ${formatPrice(total, 0)}.`,
                    );
                }

                setDeposit(total);
            } else {
                setDeposit(detDefy?.challengePriceTeam);
            }
        }
    }, [detDefy]);

    useEffect(() => {
        if (detDefy) {
            //console.log({ detDefy });
            if (detDefy.challengedTeam && detDefy.challengerTeam && capacity) {
                setTitle(`Partido ${capacity} ${detDefy.challengerTeam?.name} vs ${detDefy.challengedTeam?.name}`);
            }
            if (detDefy.challengerParticipate === false && detDefy.challengedParticipate === false) {
                //  console.log('entre que no soy de este desafío');
                setParticipate(true);
            } else {
                setParticipate(false);
            }

            if (
                (detDefy.challengerParticipate &&
                    detDefy.challengerParticipate === true &&
                    detDefy.challengerStatusPaid === 'PENDING_PAYMENT') ||
                (detDefy.challengedParticipate &&
                    detDefy.challengedParticipate === true &&
                    detDefy.challengedStatusPaid === 'PENDING_PAYMENT')
            ) {
                // console.log('aqui entro puede pagar');
                setStatusPay(true);
            } else if (
                (detDefy.challengerParticipate &&
                    detDefy.challengerParticipate === true &&
                    detDefy.challengerStatusPaid === 'PARTIAL_PAYMENT') ||
                (detDefy.challengedParticipate &&
                    detDefy.challengedParticipate === true &&
                    detDefy.challengedStatusPaid === 'PARTIAL_PAYMENT')
            ) {
                setStatusPay(true);
            } else if (
                (detDefy.challengerParticipate &&
                    detDefy.challengerParticipate === true &&
                    detDefy.challengerStatusPaid === 'NOT_PAID') ||
                (detDefy.challengedParticipate &&
                    detDefy.challengedParticipate === true &&
                    detDefy.challengedStatusPaid === 'NOT_PAID')
            ) {
                setStatusPay(true);
            } else if (
                (detDefy.challengerParticipate &&
                    detDefy.challengerParticipate === true &&
                    detDefy.challengerStatusPaid === '') ||
                (detDefy.challengedParticipate &&
                    detDefy.challengedParticipate === true &&
                    detDefy.challengedStatusPaid === '')
            ) {
                setStatusPay(true);
            } else {
                setStatusPay(false);
                // console.log('aqui entro NO puede pagar');
            }
        }
    }, [detDefy]);

    const createPayment = async (reservationId) => {
        try {
            const response = await createModel('payments/webpay/create')({
                reservationId: reservationId,
            });
            // console.log('aqui response payments/webpay/create:', { response });
            if (response?.data?.url && response?.data?.token) {
                const url = `${response.data.url}?token_ws=${response.data.token}`;
                window.location.href = url;
            }
            setIsRedirecting(false);
        } catch (error) {
            //    console.log('aqui llegue', { error });
            setIsRedirecting(false);
            setError('Ocurrio un error, le notificaremos al correo para que pueda realizar el pago correspondiente');
        }
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError('');
        setIsRedirecting(true);

        if (!error && detDefy && detDefy.reservation && detDefy.reservation.id) {
            createPayment(detDefy.reservation.id);
        }
    };

    const subTitle = '';

    useEffect(() => {
        if (auth && auth.isLoggedIn && auth.user) {
            setName(auth.user.firstName + ' ' + auth.user.lastName);
            setEmail(auth.user.email);
            setPhone(auth.user.phone ? auth.user.phone : '');
        }
    }, [auth]);

    return (
        <Layout navProps={{ title: 'Inscripción | Supermatch', description: 'Inscripción Supermatch' }}>
            <>
                <Header />
                <LayoutInside attribute={attribute} title={title} subTitle={subTitle} breads={breads}>
                    <>
                        {timeDefy && (
                            <p className="text-center text-2xl italic text-red-500 pt-5">
                                La fecha de este desafío ya paso
                            </p>
                        )}
                        {error && (
                            <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center  font-bold">
                                <p className="w-full my-6 text-red-500">*{error}</p>
                            </div>
                        )}
                        {defy.isLoading ? (
                            <Loading />
                        ) : detDefy && !statusCancel && !participate && dateMatch ? (
                            <>
                                {msj && (
                                    <div className="flex flex-col mx-auto w-full md:w-1/3 mb-2 text-center font-bold whitespace-pre-line">
                                        <p className="w-full text-xl my-6 text-green-500">{msj}</p>
                                    </div>
                                )}
                                <div className="w-full md:w-3/5 lg:w-1/2 mx-auto flex-none md:flex  py-4 md:py-6 md:px-16 border-2 bg-white shadow-lg rounded-xl">
                                    <div className="w-full md:w-2/3 px-4 md:px-0 pb-10 md:pb-0 ">
                                        <PaymentLabels
                                            title="Fecha"
                                            icon="date"
                                            value={`${dateMatch.date}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Desde"
                                            icon="time"
                                            value={`${dateMatch.start} Hrs - ${dateMatch.end} Hrs`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Cancha"
                                            icon="field"
                                            value={`${
                                                detDefy.fieldRealName
                                                    ? detDefy.fieldRealName
                                                    : detDefy.reservation.field?.name
                                            }`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Lugar"
                                            icon="club"
                                            value={`${detDefy.reservation.field?.club?.name}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels
                                            title="Dirección"
                                            icon="location"
                                            value={`${detDefy.reservation.field?.club?.address}`}
                                            sport={sport}
                                        />
                                        <PaymentLabels title="Nombre" icon="user" value={`${name}`} sport={sport} />
                                        <PaymentLabels title="Email" icon="email" value={`${email}`} sport={sport} />
                                        {phone && (
                                            <PaymentLabels title="Teléfono" icon="phone" value={phone} sport={sport} />
                                        )}
                                        {detDefy && detDefy.challengePriceTeam && (
                                            <PaymentLabels
                                                title="Total"
                                                icon="pay"
                                                value={`${formatPrice(detDefy.challengePriceTeam, 0)}`}
                                                sport={sport}
                                            />
                                        )}
                                    </div>
                                    <div className="w-full md:w-2/6 text-center justify-center content-center">
                                        <h3 className="text-xl font-bold italic text-sm-blue-primary pb-4">
                                            {detDefy?.reservation?.discountPercentage > 0
                                                ? 'Abono a pagar por equipo'
                                                : 'Total a pagar por Equipo'}
                                        </h3>

                                        {deposit && (
                                            <div className="flex flex-col text-center justify-center content-center">
                                                <p className="text-4xl pt-4 font-bold italic text-sm-integrate">{`${formatPrice(
                                                    deposit,
                                                    0,
                                                )}`}</p>
                                                {/*validar que el metodo de pago de pago se el correcto */}
                                                <Image
                                                    className="mx-auto px-6 pt-8"
                                                    imgClassName=""
                                                    src={WebPayLogo}
                                                    alt="WebPay"
                                                    width={150}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {statusPay ? (
                                    <div
                                        className="flex flex-col mx-auto w-full md:w-1/3 mt-6 mb-2"
                                        ref={inputRefButton}
                                    >
                                        <Button
                                            title={isRedirecting ? 'Espera un momento...' : 'Pagar'}
                                            handlerClick={handleSubmit}
                                            disabled={isRedirecting}
                                        />
                                    </div>
                                ) : (
                                    <div className="container mx-auto  w-full md:w-3/5 lg:w-1/2 flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                        <div className="w-full text-center content-center items-center">
                                            <div className={`bg-yellow-500  text-white uppercase py-4 font-extrabold`}>
                                                Desafío Pagado
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                {participate && (
                                    <div className="container mx-auto  flex-col text-center content-center items-center pt-0 md:pt-5  space-x-8">
                                        <div className="w-full text-center content-center items-center">
                                            <div className={`bg-red-500  text-white uppercase py-4 font-extrabold`}>
                                                Error este Desafío no pertecene al jugador que esta realizado la
                                                peticion
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                </LayoutInside>
            </>
        </Layout>
    );
};

export default Challenge;
